<sbf-error-shell [errorNumber]="500" message1="THE SERVER ENCOUNTERED AN INTERNAL ERROR OR MISCONFIGURATION AND WAS UNABLE TO COMPLETE YOUR REQUEST" message2="KEEP EXPLORING"></sbf-error-shell>
